import { TokenService } from './token.service';
import { Intercom } from 'ng-intercom';
import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntercomService {

  private initialized: boolean = false;

  private updateInterval: any;

  constructor(
    private intercom: Intercom,
    private tokenService: TokenService
    ) { }

  public start(): void {
    if (!this.isProductionEnvironment()) {
      return;
    }
    const user = this.tokenService.user;
    let userData: any = {
      app_id: 'qz0rtcot',
			name: user.name,
			email: user.email,
      user_id: ''+user.id,
    }
    try {
      // We're sending company data to intercom, if it's showorom we grab it from showroom property
      if (user.role == 'sales' || user.role == 'showroom_admin') {
        userData = {
          ...userData,
          type: 'retailer',
          company_name: user.showroom.name,
          company_email: user.showroom.location.email,
          company_phone: user.showroom.location.phone,
          company_address: user.showroom.location.address
        }
      // If it's a vendor user his company data is inside vendor property
      } else if (user.role == 'vendor_admin' || user.role == 'vendor_user') {
        userData = {
          ...userData,
          type: 'manufacturer',
          company_name: user.vendor.name,
          company_email: user.vendor.order_email,
          company_phone: user.vendor.phone,
          company_address: user.vendor.address
        }
      } else {
        userData = {
          ...userData,
          company_name: 'Persist Digital',
          company_email: '',
          company_phone: '',
          company_address: ''
        }
      }
    } catch (e) {
      //
    }
		this.intercom.boot({
			...userData
			// Supports all optional configuration.
			// widget: {
			//   'activator': '#intercom'
			// }
    });
    this.initialized = true;
  }

  public emit(event: string, update = true): void {
    if (!this.isProductionEnvironment()) {
      return;
    }
    this.intercom.trackEvent(event);
    if (!update) return;
    setTimeout(() => {
      this.intercom.update();
    }, 5000);
  }

  public open(): void {
    if (!this.isProductionEnvironment()) {
      return;
    }
    if (!this.initialized) {
      this.start();
    }
    this.intercom.showNewMessage();
  }

  public close(): void {
    if (!this.isProductionEnvironment()) {
      return;
    }
    clearInterval(this.updateInterval);
    this.intercom.shutdown();
  }

  private isProductionEnvironment(): boolean {
    return environment.production && !window.location.hostname.startsWith('qa-pricing');
  }
}
